/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { parseEachWayFraction } from './eachWayFraction';

const marketType = {
  EACH_WAY: 'win_or_ew',
  PLACE: 'place',
  WIN: 'win',
  SP: 'sp',
  TRICAST: 'tricast',
  FORECAST: 'forecast',
}

const SPOdds = 'SP'
const N_A = 'N/A';

export function calculateNoTax(betslip, tax) {
  const isSP = betslip.odds == SPOdds;

  let odds = betslip.odds;
  let winningTax: number | string = SPOdds;
  let possibleWinnings: number | string = SPOdds;

  if (betslip.marketType === marketType.FORECAST || betslip.marketType === marketType.TRICAST) {
    odds = null;
    possibleWinnings = N_A;
    winningTax = N_A;
  } else if (betslip.isSelectionBet) {
    const totalWin = Number(betslip.odds) * Number(betslip.amount);
    winningTax = Number(tax) * totalWin;
    possibleWinnings = totalWin - Number(winningTax);
  } else if (betslip.marketType === marketType.EACH_WAY || betslip.marketType === marketType.SP) {
    const totalWin = isSP ? SPOdds :
      betslip.eachWayBet ?
        ((betslip.odds * betslip.amount) + (((betslip.odds - 1) * parseEachWayFraction(betslip.eachWayFraction) + 1) * betslip.amount)) :
        betslip.odds * betslip.amount

    winningTax = betslip.odds == SPOdds ? SPOdds : (Number(tax) * Number(totalWin));
    possibleWinnings = betslip.odds == SPOdds ? SPOdds : (Number(totalWin) - Number(tax) * Number(totalWin));
  }
  return {
    odds,
    winningTax,
    possibleWinnings,
  }
}

export function calculateTotalPaidAmountNoTax(currentTab, betslips, totalStakeMultiple, eachWayBetMultiple = false) {
  if(currentTab === 'SINGLE') {
    return betslips.reduce((value, item) =>
      value + (+item.amount * (item.eachWayBet ? 2 : 1))
      , 0)
  } else {
    return eachWayBetMultiple ? totalStakeMultiple * 2 : totalStakeMultiple;
  }
}

export function calculatePossibleWinningsNoTax(currentTab, betslips, totalStakeMultiple, eachWayBetMultiple = false) {
  if(betslips.some(x => x.odds == null || x.odds === 'SP')) {
    return 'SP';
  }

  if(currentTab === 'SINGLE') {
    return betslips.reduce((acc, betslip) => acc + Number(betslip.possibleWinnings), 0);
  } else {
    const odds = betslips.reduce((acc, betslip) => acc * Number(betslip.odds), 1);
    return odds * (eachWayBetMultiple ? totalStakeMultiple * 2 : totalStakeMultiple);
  }
}